export default {
  okr: {
    createOkr: '创建目标',
    copyOkr: '复制目标',
    editOkr: '编辑目标',
    alignTarget: '对齐目标',
    targetName: '目标名称',
    fromOkrDemoAdd: '从案例库添加',
    inputOkrName: '请输入目标名称',
    reminderUpdateOkr: '提醒成员更新目标计划',
    keyResults: '关键成果',
    addKeyResults: '添加关键成果KR',
    OnlyMembersLook: '仅相关成员可见',
    OnlyDepartmentLook: '仅部门可见',
    customVisibleRange: '自定义可见范围',
    targetNameRequired: '目标名称必填',
    targetcycleRequired: '目标周期必填',
    k_r_NameRequired: '关键成果，KR名称必填',
    k_r_s_e_Required: '关键成果，KR起止时间必填',
    annual: '年度',
    firstQuarter: '第一季度',
    secondQuarter: '第二季度',
    thirdQuarter: '第三季度',
    fourthtQuarter: '第四季度',
    okrTime: '目标时间',
    okrState: '目标状态',
    okrPer: '目标负责人',
    allOkr: '全部目标',
    allCycle: '全部周期',
    clearOption: '清空选项',
    remberOption: '记住选项',
    leastOneChoooseKR: '最少选择一个KR',
    leastOneChoooseOKROrKR: '最少选择一个目标或KR',
    leastOneChoooseOKR: '最少选择一个目标',
    relevanceKr: '关联KR',
    okrScreen: '目标筛选',
    changeOkr: '切换目标',
    isDangerous: '有风险',
    HasBeenPostponed: '已延期',
    abnormal: '异常',
    createKr: '创建KR',
    createTask: '创建任务',
    s_s_kr: '所属KR',
    selectKR: '选择关联KR',
    set_s_e_time: '设置起止时间',
    targetValue: '目标值',
    workingHours: '预估工时',
    RequiredPerson: '负责人必填',
    p_s_r_kr: '请选择关联KR',
    taskNameRequired: '任务名称必填',
    t_v_2: '目标值最多2位小数',
    w_t_1: '预估时间最多1位小数',
    p_i_title_c_task: '输入标题新建任务',
    okrTarget: '战略管理',
    targetPlan: '目标计划',
    project_z_x: '项目执行',
    checkReject: '校验驳回',
    resetCheck: '重新校验',
    kr_progross: 'KR完成度',
    x_x_z_s: '信心指数',
    autoUpdate: '自动更新',
    editProgross: '点击修改进度',
    s_e_time: '起止时间',
    kr_q_z: 'KR权重',
    kr_p_f: 'KR评分',
    click_edit: '点击修改',
    p_f_remark: '评分说明',
    not_p_f_remark: '暂无评分说明',
    j_z: '进展',
    f_p: '复盘',
    input_j_z: '填写进展',
    fillPerson: '填写人',
    add_j_z: '添加了进展',
    kr_c_p: 'KR当前进度为',
    j_z_date: '进展日期',
    allOperation: '全部操作',
    add_f_p: '添加复盘',
    screen_time: '筛选时间',
    p_f: '评分',
    p_j: '评价',
    delete_j_z_r: '确定要删除该进展说明吗？',
    j_z_remark: '进展说明',
    kr_p_f_r: 'KR评分必填',
    kr_p_j_r: 'KR评价必填',
    p_f_detail: '评分详情',
    is_check: '是否校验',
    not_check: '不校验',
    delete_kr_goon: '此操作将永久删除该KR, 是否继续？',
    input_p_f_j: '请输入评分评价',
    is_reset_check: '是否重新开启校验？',
    check_status: '校验状态',
    to_check: '待校验',
    input_pass_c: '请输入通过原因',
    input_reject_c: '请输入驳回原因',
    kr_name: 'KR名称',
    s_y_time: '剩余',
    g_q_time: '已过期',
    kr_tip_1: '添加KR：尽量少用「参与」、「帮助」、「分析」这类难以衡量结果的词汇',
    kr_tip_2: '添加KR：你的KR可以用数字来衡量吗？',
    kr_tip_3: '添加KR：对自己狠一点，写一个清晰可衡量的KR',
    kr_tip_4: 'KR要可衡量，不写「混水摸鱼」式KR',
    kr_tip_5: 'KR是结果来描述，不是待办任务',
    alignment_my: '对齐我的',
    okr: '目标',
    remind_per_update_okr: '提醒成员更新计划',
    remind_up_look: '提醒上级查看',
    copyOkr_1: '复制目标',
    stopOkr: '结束目标',
    resetOkr: '重启目标',
    editOkr_1: '编辑目标',
    deleteOkr: '删除目标',
    select_d_q_okr: '选择对齐目标',
    system_auto_kr: '系统根据KR进度和权重自动进行计算',
    c_e_q: '点击修改权重',
    krTask: 'KR任务',
    add_keyResults: '添加关键结果',
    sure_stop_okr: '确定要结束该目标吗？',
    sure_reset_okr: '确定要重启该目标吗？',
    okr_state: '目标状态',
    sure_del_okr: '确定要删除该目标吗？删除后目标以及目标下的KR和任务将同时删除。',
    d_z_per: '点赞人',
    complete_pro: '完成度',
    x_g_per: '相关人员',
    l_h: '量化',
    s_j_z: '实际值',
    normal: '正常',
    j_j: '紧急',
    f_c_j_j: '非常紧急',
    max_progress_100: '进度最大值为100',
    max_weight_100: '权重最大值为100%',
    progress_100_is_complete: '任务进度已达100%，是否将任务状态更改为已完成？',
    task_p_range_100: '任务进度可选范围0-100',
    add_task: '添加任务',
    update_for: '更新于',
    folder: '文件夹',
    by_create_time: '按创建时间',
    by_start_time: '按开始时间',
    by_end_time: '按结束时间',
    all_state: '所有状态',
    file: '文件',
    all_d_t: '全部动态',
    all_files: '全部文件',
    create_kr: '创建关键成果KR',
    change_k_b_view: '切换为看板视图',
    checking: '校验中',
    progress_normal: '进度正常',
    progress_risks: '进度有风险',
    progress_postponed: '进度已延期',
    progress_abnormal: '进度异常',
    s_s_o: '所属',
    schedule_task: '计划任务',
    weight: '权重',
    current_progress: '当前进度',
    progress_s: '进度说明',
    input_progress_s: '请输入进度反馈说明',
    update_kr_progress: '更新KR权重',
    update_kr_weight: '更新KR进度',
    update_okr_weight: '更新目标进度',
    all_target_task: '全部目标任务',
    task_time: '任务时间',
    task_status: '任务状态',
    my_x_z: '我协作的',
    sys_def_sort: '系统默认排序',
    okr_dep_c_p: '各部门目标平均完成度',
    okr_all_c_p: '目标整体平均完成度',
    task_num: '任务数量',
    okr_count: '目标总数',
    overdue: '已逾期',
    complete_kr: '已完成KR',
    key_result_view: '关键结果概览',
    okr_view: '目标概览',
    to_check_kr: '待校验KR',
    task_view: '任务概览',
    task_count: '任务总数',
    due_today: '今日到期',
    y_q_complete: '逾期完成',
    y_q_n_complete: '逾期未完成',
    task_c_z_b: '任务完成占比',
    task_y_q_count: '任务逾期数量',
    kr_core: 'KR 评分分布',
    task_c_num: '任务完成数量',
    not_core: '未评分',
    score_0_3: '0-3分',
    score_4_5: '4-5分',
    okr_num: 'KR数量',
    s_e_required: '开始时间和截止时间必填',
    s_n_m_e_time: '开始时间不能大于截止时间',
    create_okr: '创建目标',
    my_okr_tarte: '我的目标计划',
    sub_target_okr: '下属目标计划',
    pending_task: '待定任务',
    today_work: '今日工作',
    to_determined: '待定',
    year_quarter: '年/季',
    year_plan: '年度计划',
    week_1: '第1周',
    week_2: '第2周',
    week_3: '第3周',
    week_4: '第4周',
    main_task: '所属主任务',
    task_properties: '任务属性',
    task_ref_okr: '任务关联目标',
    task_ref_kr: '任务关联KR',
    improvement_plan: '改进计划',
    demo_info_1: '目标：按照',
    demo_info_2: '关键成果（KR）',
    demo_info_3: '来衡量',
    demo_info_4: '任务：我们将通过',
    demo_info_5: '计划执行（任务）',
    demo_info_6: '来达成关键成果（KR）',
    demo_info_7: '套用',
    y_y: '运营',
    s_c: '市场',
    x_s: '销售',
    r_l: '人力',
    y_f: '研发',
    c_p: '产品',
    c_w: '财务',
    mamage_view: '管理视图',
    y_b_p: '仪表盘',
    personel_view: '个人视图',
    change_light: '切换浅色模式',
    change_dark: '切换深色模式',
    see_org_members: '查看组织成员',
    view_dep: '按部门查看',
    view_members: '按成员查看',
    company_okr: '机构目标',
    select_iewer: '选择查看人员',
    input_key_s_okr: '输入关键字搜索目标',
    show_kr: '显示KR',
    show_task: '显示任务',
    show_leavel: '显示层级',
    show_more: '展示更多',
    now_not_okr: '当前尚未制定目标',
    create_okr_1: '创建目标',
    okr_set: '目标设定',
    okr_result_z_z: '目标结果追踪',
    okr_result_f_x: '目标结果分析',
    copy_share_link: '复制分享链接',
    copy_link: '复制链接',
    copy_link_send: '复制链接发送，可点击链接查看当前地图',
    link_addr: '链接地址',
    update_x_x: '更新信息指数',
    current_x_x: '当前信心指数',
    x_x_remark: '信心指数说明',
    p_i_x_x_r: '请输入信心指数说明',
    input_1_10_num: '请输入1-10之间的数字',
    have_aligned: '已对齐',
    have_split: '已分解',
    not_aligned: '未对齐',
    not_split: '未分解',
    okr_data_detail: '目标数据详情',
    search_dep_name: '搜索姓名和部门',
    y_b_p_info_1: '目标 填写率',
    y_b_p_info_2: '填写率=员工至少已负责一个目标的比例',
    y_b_p_info_3: '目标 对齐率',
    y_b_p_info_4: '对齐率=有关联母目标的目标比例',
    y_b_p_info_5: '项目执行分解率',
    y_b_p_info_6: '关键成果分解=有进行执行任务分解的KR比例',
    y_b_p_info_7: '每个人负责的 目标 数量分布',
    y_b_p_info_8: '单周期内个人负责目标数量1-3个最佳，最多不超过5个',
    y_b_p_info_9: '未设置目标',
    y_b_p_info_10: '1-5个目标',
    y_b_p_info_11: '5个以上目标',
    y_b_p_info_12: '目标下的 KR 数量分布',
    y_b_p_info_13: '每个目标中KR数量以3-5个为最佳',
    y_b_p_info_14: '未设置KR',
    y_b_p_info_15: '1-2个KR',
    y_b_p_info_16: '3-5个KR',
    y_b_p_info_17: '5个以上KR',
    y_b_p_info_18: '目标对齐量',
    y_b_p_info_19: 'KR分解',
    y_b_p_info_20: '一周内未更新的目标',
    y_b_p_info_21: '一周内未更新进展的 目标数量',
    y_b_p_info_22: '一周内未更新的KR',
    y_b_p_info_23: '一周内未更新进展的 KR数量',
    y_b_p_info_24: '一周内未更新的任务',
    y_b_p_info_25: '一周内未更新进展的 执行任务数量',
    y_b_p_info_26: '目标数量',
    y_b_p_info_27: 'KR数量',
    y_b_p_info_28: '总人数',
    y_b_p_info_29: '总目标',
    data_list: '数据列表',
    remind_info:
      '请及时更新 实现机构立足深圳 的计划执行。\n要求：\n1.针对这个目标做好KR和任务分解\n2.关键结果KR是支持目标的重要因素，是可量化的\n3.直击要点，不要模棱两可',
    select_dep_view: '选择部门查看',
    i_know: '我知道了',
    key_to_remind: '一键提醒',
    remin_info_1: '提醒成员添加目标',
    remin_info_2: '请尽快添加目标',
    remin_info_3: '提醒目标负责人添加关键成果',
    remin_info_4: '请尽快为目标添加关键成果',
    remin_info_5: '提醒目标负责人对齐目标',
    remin_info_6: '请尽快为目标添对加齐',
    remin_info_7: '提醒关键成果负责人添加执行任务',
    remin_info_8: '请尽快为关键成果添加执行任务',
    remin_info_9: '提醒更新目标进展',
    remin_info_10: '请及时更新目标进展，包括当前阶段性成果、工作障碍点',
    remin_info_11: '提醒更新关键成果进展',
    remin_info_29: '提醒更新执行任务',
    remin_info_30: '请及时更新关键成果进展，包括当前阶段性成果、工作障碍点',
    remin_info_12: '请及时更新执行任务，包括当前阶段性成果、工作障碍点',
    remin_info_13: '提醒目标负责人为关键结果KR评分',
    remin_info_14: '请尽快为以下KR进行评分',
    remin_info_15: '未设置目标的成员',
    remin_info_16: '设置1-5个目标的人员',
    remin_info_17: '设置5个以上目标的人员',
    remin_info_18: '未添加关键成果的目标',
    remin_info_19: '设置1-2个关键成果的目标',
    remin_info_20: '设置5个以上关键成果的目标',
    remin_info_21: '设置3-5个关键成果的目标',
    remin_info_22: '未添加对齐的目标',
    remin_info_23: '已添加对齐的目标',
    remin_info_24: '未添加执行任务的关键成果',
    remin_info_25: '已添加执行任务的关键成果',
    remin_info_26: '未进行评分的KR',
    remin_info_27: '评分0-3分的KR',
    remin_info_28: '评分4-5分的KR',
    okr_demo_t_1: '结合目标用户群体核心需求，提出对当前产品的优化建议，提升用户使用粘性',
    okr_demo_t_2:
      '梳理现有产品功能使用情况，完成用户调研报告，明确用户群体核心需求，提出增强用户粘性的',
    okr_demo_t_3: '优化现有 XX 标签体系，推送精准率提高至 40%，平均用户在线时长提升 20%',
    okr_demo_t_4: '协同产品部门完成相关功能上线，日活跃用户规模达到 500 万水平，用户流失率下降 10%',
    okr_demo_t_5: '实现 XX 产品用户量与用户活跃度的提升，为营收增长提供保障',
    okr_demo_t_6: '减少负反馈比例至 10%，客户留存率提升至 60% ',
    okr_demo_t_7: '上线 XX 活动，鼓励老用户回归，活跃客户数达到 500 万 ',
    okr_demo_t_8: '上线拉新相关的 XX 活动，吸引潜在消费者，新增注册客户数达 10 万',
    okr_demo_t_9: '优化 XX 产品的奖励回馈机制，使得用户在产品界面的停留时长上升 10% ',
    okr_demo_t_10: '提升 XX 产品的市场知名度',
    okr_demo_t_11: '与 XX 渠道达成新的合作关系，粉丝数量提升 10%',
    okr_demo_t_12: '发布 10 篇阅读量 5w+ 的高质量公关文章，话题讨论参与人数达 100 万',
    okr_demo_t_13: '通过联动等活动，提升微博、微信、头条号等主流媒体的话题活跃度 20% ',
    okr_demo_t_14: '保持 XX 品牌领先优势，提升品牌知名度与影响力',
    okr_demo_t_15:
      '品牌策略：重新定义 XX 品牌，差异化表达品牌理念，以专项形式落地品牌策略，产出 10 个宣传素材，总曝光量达到 1 亿',
    okr_demo_t_16:
      '品牌宣传：首月完成 1 支混剪出街视频，本次 目标 周期结束前完成 XX 新品牌的视频拍摄',
    okr_demo_t_17:
      '渠道合作：共创顶级 IP 合作（博物馆、历史文化、艺术、公益），吸引 10 个 XX 站粉丝量在 10 万以上的品牌账号入驻',
    okr_demo_t_18: '渠道推广：赞助一场大型公开性活动，吸引1000个公众号关注',
    okr_demo_t_19: '沉淀创意经验和品牌管理方法论，输出中台支持能力',
    okr_demo_t_20: '完成素材中心系统的搭建，本周期内形成至少 1,000 份创意素材',
    okr_demo_t_21:
      '形成一套高质量的素材撰写方法论，提升整体员工撰写素材的效率和质量，至少缩短素材撰写周期 30%',
    okr_demo_t_22: '通过在新社交媒体上的线上引流活动，提升活跃粉丝数量',
    okr_demo_t_23: '每周至少撰写 10 篇高质量推文，单篇阅读量不低于 10 万，周期内新增粉丝数 5 万 ',
    okr_demo_t_24:
      '至少开展 10 场线上转发抽奖活动，单场平均转发量不低于 1 万，参与活动的粉丝占比不低于 30% ',
    okr_demo_t_25: '进行推文数据分析，并根据结果调整写作方式，下半月阅读量均值比上半月提升 10%',
    okr_demo_t_26: '赋能销售团队，提升销售团队效率',
    okr_demo_t_27:
      '在 1 月底之前，制定销售技能认证机制，规范不同技能组合的培训内容，形成标准化讲义，最终确保全体销售成员通过认证',
    okr_demo_t_28: '丰富销售团队梯度，本周期内入职 3 名高级销售经理',
    okr_demo_t_29: '实施 XX 新流程，缩短正常流程时间至一周以内',
    okr_demo_t_30: '为销售提供数据分析支持，提供销售决策建议',
    okr_demo_t_31:
      '平台搭建 - 建立销售分析和 BI 商业智能平台，确保数据的完整性和可提取性，缩短业务数据分析时间 20%',
    okr_demo_t_32: '商机库建设 - 完成商机库一期建设，匹配存量客户，关联和打通客户信息',
    okr_demo_t_33:
      '数据报告 - 活动指标、渠道指标和结果指标自动生成摘要报告，并发送给销售人员，节省销售人工填写报告时间 1 小时',
    okr_demo_t_34: '深耕北区市场，销售额达到 1,000 万美金，达成机构第一季度销售额目标',
    okr_demo_t_35:
      '第 1 季度参加 3 次北区行业活动，收获有效线索 30 条以上，保证线索转化率不低于 20%',
    okr_demo_t_36: '优化信息同步机制，及时梳理销售线索和团队资源，确保信息同步不隔天',
    okr_demo_t_37: '至少 60% 的销售团队完成配额',
    okr_demo_t_38: '加大组合销售策略的推广力度，确保 40% 以上的营业额来自于预定销售和套餐销售',
    okr_demo_t_39: '完成团队规模和结构升级，本月招聘计划完成率提升至 80% 以上',
    okr_demo_t_40: '本月至少完成 3 条新招聘渠道的扩展，各渠道每月推送人才线索量应不低于 1,000',
    okr_demo_t_41: '丰富销售团队梯度，本周期内入职 3 名高级销售经理',
    okr_demo_t_42: '完成机构紧缺人才的招募，本月招聘完成率不低于 90% ',
    okr_demo_t_43: '优化高管团队的薪酬方案，提高薪酬方案的激励性',
    okr_demo_t_44:
      '完成对高管团队的薪酬满意度调研，覆盖率需达到 95%，基于调研结果制定一套薪酬方案优化建议书，获得董事会批准通过 ',
    okr_demo_t_45: '对标同行业最佳实践，完成股权激励方案的设计，并获董事会批准通过',
    okr_demo_t_46:
      '推广实施新的薪酬方案，落地 2 个月后进行第二次薪酬满意度调研，满意度不低于 90%，并基于调研结果提出至少 5 条被董事会采纳的可行性改进建议',
    okr_demo_t_47: '优化现有培训知识体系和平台，形成「全员学习」的机构文化',
    okr_demo_t_48: '搭建线上培训平台并推广落地，高层试点覆盖率不低于 95%，全员覆盖率不低于 60%',
    okr_demo_t_49: '扩充现有培训知识库，每月需至少产出 10 套精品课程，课程内容满意度不低于 90%',
    okr_demo_t_50:
      '优化现有的培训考核体系，倡导「全员学习」的理念，3 个月内全员平均培训参与度和各类考试平均分值通过率不低于 80%',
    okr_demo_t_51: '为 XX 业务提供高效稳定的系统支持',
    okr_demo_t_52: '优化 XX 算法，缩短系统对客户需求的响应时间至 0.1 秒，同时维持 Bug 率不变',
    okr_demo_t_53: 'XX 方案平稳落地，Bug 率控制在 3% 之内，系统无重大事故',
    okr_demo_t_54: '新建 XX 评估方案与 XX 模型，实现「系统稳定性」的可量化统计分析',
    okr_demo_t_55: '打造完善的企业数据中台，实现所有产品数据的可积累、可溯源',
    okr_demo_t_56: '完成数据中台框架设计与方案设计，获得高管层、业务端一致通过 ',
    okr_demo_t_57: '完成数据中台初代版本的模型搭建，稳定性保持在 99.9% 以上，无重大事故',
    okr_demo_t_58: '初代版本达成后实现主营业务各环节数据 100% 可溯源、可统计',
    okr_demo_t_59: '为即将开始的 XX 业务储备好充分的研发人才',
    okr_demo_t_60: '招聘测试工程师 10 人（满足 XX 要求），提升团队 XX 能力',
    okr_demo_t_61: '从一线大厂招聘有相似业务经历的 Leader 1 人，带来成熟的业务经验',
    okr_demo_t_62: '新业务组全员进行 XX 课程培训并全部通过测试（60 分），确保 XX 能力达标',
    okr_demo_t_63: '进军 XX 赛道，完成赛道内初代产品设计',
    okr_demo_t_64: '通过调研用户圈层，提炼用户核心需求，输出相关统计结果',
    okr_demo_t_65: '根据调研结果，确定产品 XX 发展方向，并输出产品方案，获得各团队认可',
    okr_demo_t_66: '进行灰度测试并优化产品，在周期内提升测试用户满意度至 90% ',
    okr_demo_t_67: '完成产品基础能力优化，提升用户满意度',
    okr_demo_t_68: '调整 XX 体系，优化 XX 功能，用户满意度从 85% 提升至 90% ',
    okr_demo_t_69: '引入 XX 系统，强化产品 XX 能力 ，打通与业务团队 XX 的数据',
    okr_demo_t_70: '完成产品需求的排期，明确当前所有需求的实现顺序，保证 P0 需求如期完成',
    okr_demo_t_71: '优化 XX 产品的重点功能和体验，充分满足商业化要求',
    okr_demo_t_72: 'X 月 X 日前完成 XX 功能，满足 XX 应用商店上架标准',
    okr_demo_t_73: '在本次 目标 周期前，打通 Y 产品的账户，支持免注册登录，免注册用户占比达到 20% ',
    okr_demo_t_74: '上架 1 个月内完成 2 个关键功能的 A/B 测试，提升平均页面留存率至 20% ',
    okr_demo_t_75: '建立规范的预算管理体系，提升预算监控能力',
    okr_demo_t_76:
      '完成机构整体预算项目的梳理，明确预算项目和核算项目之间的映射关系，搭建一套完整、清晰的预实对比和分析体系（例如：明确分析周期、维度等）',
    okr_demo_t_77:
      '新版财务日报上线，展示科目和维度需进一步细化（依 XX 会议商定标准），数据更新周期缩短至 T+8',
    okr_demo_t_78: '预算监控功能上线，各部门覆盖率达到 100%，月均预警次数不低于 5 次',
    okr_demo_t_79: '优化费用管控体系，提升业务部门差旅满意度',
    okr_demo_t_80:
      '完成同业最佳实践调研和机构内部满意度调研报告，首月末前提出针对管控优化方案的 5 点建议',
    okr_demo_t_81: '基于优化方案建议，设计一套费用管控优化方案并推广实施，获得不同业务部门的认可 ',
    okr_demo_t_82:
      '上线商旅系统，优化报销体验，缩短报销流程和时长至少 50%，业务部门差旅满意度提升 50% ',
    okr_demo_t_83: '搭建财务共享服务中心，实现财务团队的降本、增效、转型',
    okr_demo_t_84:
      '引入咨询机构和技术机构，设计财务共享服务方案与平台，方案中需明确节省的人员成本和运转效率的提升程度 ',
    okr_demo_t_85:
      '落地财务共享服务方案，完成财务人员的集中管理，至少覆盖集团下属 80% 以上的子机构',
    okr_demo_t_86:
      '完成 SSC 人员的职能专业化分工，效率提升比例不低于 50%（总工时统计）；以及本地财务人员的释放和业务转型，释放和转型比例不低于 30%',
    f_p_obj: '复盘对象',
    f_p_content: '复盘内容',
    reference_data: '关联数据',
    edit_plan: '改进计划',
    create_action_plan: '创建行动计划',
    f_p_info_1: '价值与收获',
    f_p_info_2: '我们从过程中学到了什么新东西?',
    f_p_info_3: '如果有人要进行同样的行动, 我会给他什么建议?',
    f_p_info_4: '问题与不足',
    f_p_info_5: '请描述出现的某个问题并针对该问题展开分析',
    f_p_info_6: '根本原因',
    f_p_info_7: '请填写问题出现的根本原因',
    f_p_info_8: '相应解决措施',
    f_p_info_9: '请根据上述原因给出可落地的解决措施',
    f_p_c_not_empty: '复盘内容不能为空！',
    task_personnel_principal: '任务负责人',
    kr_key_result: '关键结果',
    okr_y_q: '逾期',
    alignKr: '对齐KR',
    belong_to_okr: '所属目标',
    okrNameRoleCreattime: '目标名称、角色、创建时间',

    // 2022-05-31
    systemAutoComHours: '系统自动计算消耗工时，在完成任务后计算',
    yixiaohao: '已消耗',
    plan_time: '计划工时',
    recommend_progress: '推荐进度',
    reference_form_data: '关联表单数据',
    restart_task: '重启任务',
    update_progress: '更新进度',
    update_task_hours: '更新任务工时',
    the_use: '本次使用',
    expected_time: '预计工时',
    stop_task: '暂停任务',
    hours_not_empty: '工时不能为空',
    hours_not_zero: '工时不能等于0',
    hours_less_zero: '工时不能小于0',
    task_completion_time_requried: '任务完成时间必填',
    task_completion_time: '任务完成时间',
    task_plan_time: '任务计划工时',
    my_align: '我对齐的',
    cancel_align: '取消对齐',
    company_level: '机构级',
    department_level: '部门级',
    team_level: '团队级',
    personal_level: '个人级',
    plan_time_1decimal: '计划工时最多1位小数',
    name_not_exist_again: '名称不存在，请重新输入',
    okr_input_tips: '表明要做一件什么事，@邀请他人',
    min_value: '门槛值',
    okr_value: '目标值',
    max_value: '挑战值',
    kr_input_tips: '达成目标要实现的关键性成果，输入@邀他人',
    save_continue_add: '保存后继续添加',
    okr_reader_type_1: '本部门(仅限直属人员)和所有上级',
    okr_reader_type_2: '本部门(包含所有下级成员)和所有上级',
    okr_reader_type_3: '仅限自己和上级',
    kr_weight_error_1: 'KR权重输入有误',
    kr_weight_error_2: 'KR权重最多两位小数',
    okr_check_1: '目标类型必填',
    okr_check_2: 'KR关键成果不能为空',
    okr_check_3: '自定义可见范围必填',
    okr_check_4: '绩效指标必须满足【挑战值>=目标值>=门槛值】',
    okr_check_5: 'KR权重之和必须为100%',
    okr_review: '目标复盘',
    system_period_auto_progress: '系统根据目标周期自动计算',
    kr_result: 'KR关键成果',
    open_task: '展开任务',
    show_complate_task: '显示完成任务',
    focus_on: '关注',
    kr_period: 'KR周期',
    complate_kr_task: '已完成任务/KR下任务',
    no_okr_value_set: '未设置目标值',
    performance_zhibiao: '绩效指标',
    kr_head: 'KR负责人',
    hand_update_kr_progress: '手动更新KR进度',
    task_progress_auto_update: '按任务进度自动更新',
    sub_okr_auto_update: '按子目标进度自动更新',
    kr_progress_auto_update: '按KR的进度自动更新',
    kr_sorting: 'KR排序',
    del_okr_tips: '确定要删除该目标吗？删除后目标以及KR和KR下的所有任务将同步删除',
    jxzb_tips: '绩效指标必须满足【挑战值>=目标值>=门槛值】',
    cancel_liked: '取消点赞',
    cancel_collected: '取消收藏',
    task_progress: '任务进度',
    system_auto_computed: '系统自动计算',
    system_auto_record: '系统自动记录',
    tokr_count: '目标数',
    risk_of_delay: '延迟风险',
    okr_complate_count: '目标完成度',
    okr_complate_tip: '目标完成度=所有目标进度之和/目标数量',
    kr_result_count: 'KR成果数',
    without_update_10days_kr: '10天未更新占比KR',
    show_kr_1: '展示KR',
    show_organ_name: '展示组织名称',
    operation_key: '操作快捷键',
    dblclick: '鼠标双击',
    screen_delay_tip: '已为您筛选出【延迟风险】的',
    blueprint_perspective: '蓝图视角',
    input_kr_name: '请输入目标名称',
    zhibiao: '指标',
    system_kr_period_auto: '系统根据KR周期自动计算',
    used_hours: '使用工时',
    task_period: '任务周期',
    edit_kr: '编辑KR',
    del_task_tips: '确定要删除该任务吗？删除后当前任务以及任务下的子任务将同步删除',
    del_kr_tips: '确定要删除该KR吗？删除后KR和KR下的所有任务将同步删除',
    not_okr_tips_1: '尚未制定目标，立即',
    not_okr_tips_2: '制定目标',
    not_okr_tips_3: '如果你不知道如何制定目标，从',
    not_okr_tips_4: '目标管理 案例库导入',
    okr_visible_range: '目标可见范围',
    percent_progerss: '进度占比',
    all_kr_weight_100: 'KR权重之和必须为100%',
    okr_type_not_change: '目标类型未发生变更，不可点击确定按钮',
    visible_personnel: '可见人员',
    progress_type: '进度类型',
    select_one_okr: '请最少选择一条子目标',
    okr_progress_count_100: '勾选目标的进度占比和必须为100%',
    change_kr_weight: 'KR权重调整%',
    change_jxzb: '绩效指标调整%',
    all_users: '所有人员',
    base_setting: '基础设置',
    base_setting_tip_1: '目标管理功能控制',
    base_setting_tip_2: '标准版',
    base_setting_tip_3: '高级版',
    base_setting_tip_4: '机构级目标',
    base_setting_tip_5: '谁可以创建机构级目标',
    base_setting_tip_6: '机构负责人',
    base_setting_tip_7: '部门级目标',
    base_setting_tip_8: '谁可以创建部门级目标',
    base_setting_tip_9: '部门负责人（包含负责的所有下级部门）',
    base_setting_tip_10: '团队级目标',
    base_setting_tip_11: '谁可以创建团队级目标',
    base_setting_tip_12: '个人级目标',
    base_setting_tip_13: '谁可以创建个人级目标',
    base_setting_tip_14: '设置绩效管理员',
    base_setting_tip_15: '目标设置',
    base_setting_tip_16: '目标关联KR',
    base_setting_tip_17: '开启后，目标可关联其它目标的关键成果KR',
    base_setting_tip_18: '目标进度自动更新',
    base_setting_tip_19: '开启后，显示目标进度自动更新设置，目标进度支持自动更新',
    base_setting_tip_20: 'KR详情',
    base_setting_tip_21: '开启后，点击KR显示KR详情页，未开启则不弹窗显示KR详情页',
    base_setting_tip_22: '电子签章',
    base_setting_tip_23: '开启后，将在目标下显示电子签章功能，目标或KR需要电子签章',
    base_setting_tip_24: '目标类型',
    base_setting_tip_25: '开启后，可选择目标为机构级、部门级和个人级，通过类型区分目标',
    base_setting_tip_26: '开启后，目标详情界面显示文件页签，可上传文件',
    base_setting_tip_27: '任务设置',
    base_setting_tip_28: '开启后，将在KR下启用任务功能',
    base_setting_tip_29: '任务完成允许修改完成时间',
    base_setting_tip_30: '开启后，将在点击完成任务时间选择完成时间，否则不可选择',
    base_setting_tip_31: '任务完成校验',
    base_setting_tip_32: '开启后，在任务点击完成后触发校验，校验通过后任务才算已完成',
    base_setting_tip_33: '任务工时系统自动计算',
    base_setting_tip_34:
      '开启后，任务的使用工时系统自动计算，与考勤模块对接，请使用“考勤”模块进行排班；若任务执行人未排班，则使用工时无法自动计算',
    base_setting_tip_35: '绩效考核',
    base_setting_tip_36: '绩效申诉',
    base_setting_tip_37: '开启后，被考核人在考核结束后可对考核结果发起申诉',
    base_setting_tip_38: '绩效改进',
    base_setting_tip_39: '开启后，对考核内容进行绩效复盘',
    base_setting_tip_40: '绩效管理员',
    base_setting_tip_41: '开启后，绩效管理员可使用绩效所有功能',
    base_setting_tip_42: '预发布',
    base_setting_tip_43: '开启后，发起考核支持预发布功能，可提前公布考核事项并实时获取完成值',
    base_setting_tip_44: '请先开启KR详情功能',
    base_setting_tip_45: '请先开启任务功能',
    base_setting_tip_46: '目标类型设置',
    strategic_blueprint: '目标地图',
    create_new_kr: '新建KR',
    create_new_okr: '新建目标',
    sure_del_current_okr: '确定要删除当前目标吗？',
    tokr_preview: '目标管理视图',
    dont_move_kr_okr: '请不要将目标和KR交叉拖动，此操作是无效拖动',
    review_type: '复盘类型',
    review_okr: '复盘目标',
    upload_file: '上传附件',
    the_next_steps: '下一步行动',
    okr_review_type_1: '临时复盘',
    okr_review_type_2: '当天复盘',
    okr_review_type_3: '周例会复盘',
    okr_review_type_4: '月度列会复盘',
    okr_review_type_5: '季度复盘',
    del_review_tips: '确定要删除该目标复盘吗？',
    create_review: '新建复盘',
    okr_role: '目标所属角色',
    okr_department: '目标所属部门',
    select_align: '选择目标',
    align_okr_not_empty: '对齐目标不能为空',
    teamface_okr: '目标管理',
    initiate: '发起',
    not_auth_contact_admin: '你无权查看该模块,请联系管理员',
    my_assessment: '我的考核',
    my_score: '我的评分',
    performance_improvement: '绩效改进',
    performance_complaint: '绩效申诉',
    assessment_management: '考核管理',
    performance_templete: '绩效模板',
    performance_statistics: '绩效统计',
    personnel: '组织',
    operate: '运营',
    SystemUsageExpirationTime1: '系统使用到期时间',
    SystemUsageExpirationTime2: '请尽快联系工作人员，否则到期后系统将不可登录',
    Noreminders: '不再提醒',
    myTarget: '我的目标',
    targetMap: '目标地图',
    targetMultiple: '目标复盘',
    Organization: '组织管理',
    Employee: '员工管理',
    Salary: '薪酬管理',
    Personnelhandled: '人事待办',
    Myprofile: '我的档案',
    personnelNameNotEmpty: '人事待办名称不能为空',
    personneleContentNotEmpty: '人事待办内容不能为空'
  }
}
